define('GameDayCore/GDModel/ValueObjects/Gamecenter/Gamecenter',['require','exports','module','../ValueObjectFactory','extant/extant','./GamecenterProbable','./GamecenterVideo'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        exists = require("extant/extant");

	VO.create(Gamecenter);

	function Gamecenter($data) {
		var vo = VO.ensureVO(this, Gamecenter),
			data = $data;

		vo.status = data.status || "";
		vo.id = data.id || "";
		vo.start_time = data.start_time || "";
		vo.ampm = data.ampm || "";
		vo.time_zone = data.time_zone || "";
		vo.type = data.type || "";
		vo.away_score = data.away_score || "";
		vo.home_score = data.home_score || "";
		vo.league = data.league || "";
		vo.series_code = data["series-code"] || "";
		vo.series_game_number = data["series-game-number"] || "";
		vo.game_number = data["game-number"] || "";
		vo.ticketlink = data.ticketlink || "";
		vo.venue_short = data.venue_short || "";
		vo.venue_long = data.venue_long || "";
		vo.hasGallery = (exists(data, "gallery.exists") && data.gallery.exists != "0");
		vo.away_tv = (exists(data, "broadcast.away.tv")) ? data.broadcast.away.tv : null;
		vo.away_radio = (exists(data, "broadcast.away.radio")) ? data.broadcast.away.radio : null;
		vo.home_tv = (exists(data, "broadcast.home.tv")) ? data.broadcast.home.tv : "";
		vo.home_radio = (exists(data, "broadcast.home.radio")) ? data.broadcast.home.radio : null;
		vo.away_probables = parseProbables(data,"away");
		vo.home_probables = parseProbables(data,"home");
		vo.hasProbables = (exists(this.away_probables) && exists(this.home_probables));
		vo.away_articles = {
			preview: parseArticle(data,"away", "previews"),
			recap: parseArticle(data,"away", "recaps"),
			wrap: parseArticle(data,"away", "wrap")
		};
		vo.home_articles = {
			preview: parseArticle(data,"home", "previews"),
			recap: parseArticle(data,"home", "recaps"),
			wrap: parseArticle(data,"home", "wrap")
		};
		vo.league_articles = {
			preview: parseArticle(data,"mlb", "previews"),
			recap: parseArticle(data,"mlb", "recaps"),
			wrap: parseArticle(data,"mlb", "wrap")
		};
		vo.photos = parsePhotos(data);
		vo.condensed_video = parseVideo(data,"condensed_video");
		vo.ipad_video = parseVideo(data,"ipad_video");
	}

	function parseProbables(data,homeAway) {
		var prob = null,
			path = "probables." + homeAway,
			GamecenterProbable = require('./GamecenterProbable');

		if (exists(data, path)) {
			prob = new GamecenterProbable(data.probables[homeAway]);
		}

		return prob;
	}

	function parseArticle(data,team, gamestate) {
		var article = null;

		if (exists(data, gamestate + '.' +team)) {
			var node = data[gamestate][team];
			article = { };
			article.headline = node.headline || "";
			article.blurb = node.blurb || "";
			article.url = node.url || "";
			article.hasVideo = (exists(node.video_index));

			if (exists(node.video_index)) {
				article.video_index = { };
				article.video_index.content_id = node.video_index.content_id || "";
				article.video_index.link_type = node.video_index.link_type || "";
				article.video_index.calendar_event_id = node.video_index.calendar_event_id || "";
				article.video_index.headline = node.video_index.headline || "";
				article.video_index.blurb = node.video_index.blurb || "";
				article.video_index.thumb = node.video_index.thumb || "";
			}
		}

		return article;
	}

	function parsePhotos(data) {
		var photos = null;
		if (exists(data.photos,'ipad')) {
			photos = {};
			photos.url = data.photos.ipad.url || "";
			photos.url_retina = data.photos.ipad.url_retina || "";
			photos.ps_url = data.photos.ipad.url_ps || "";
			photos.ps_url_retina = data.photos.ipad.url_ps_retina || "";
			photos.headline = data.photos.ipad.headline || "";
			photos.caption = data.photos.ipad.caption || "";
			photos.credit = data.photos.ipad.credit || "";
		}

		return photos;
	}

	function parseVideo(data,videoType) {
		var video = null,
			GamecenterVideo = require('./GamecenterVideo');

		if (exists(data[videoType])) {
			video = new GamecenterVideo(data[videoType]);
		}

		return video;
	}

	return Gamecenter;
});
